/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RazzaCreateDTO
 */
export interface RazzaCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof RazzaCreateDTO
     */
    descrizione: string;
}

/**
 * Check if a given object implements the RazzaCreateDTO interface.
 */
export function instanceOfRazzaCreateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "descrizione" in value;

    return isInstance;
}

export function RazzaCreateDTOFromJSON(json: any): RazzaCreateDTO {
    return RazzaCreateDTOFromJSONTyped(json, false);
}

export function RazzaCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RazzaCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'],
    };
}

export function RazzaCreateDTOToJSON(value?: RazzaCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
    };
}

